module.exports = __webpack_public_path__ + "img/Filip Nawalaniec.eb600eb0.webp";